import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, ROUTER_PATHS } from '@/shared';
import {
  CreateTipoComprobanteParams,
  useCreateTipoComprobante,
  useUpdateTipoComprobante,
} from '@/shared/actions/erp';
import {
  CustomTextArea,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { TipoComprobante } from '@/shared/interfaces';
import { tipoComprobanteFormSchema } from '@/shared/utils';

export interface SaveTipoComprobanteProps {
  title: string;
  tipocomprobante?: TipoComprobante;
}

type SaveFormData = CreateTipoComprobanteParams & {};

const SaveTipoComprobante: React.FC<SaveTipoComprobanteProps> = ({
  title,
  tipocomprobante,
}) => {
  const navigate = useNavigate();
  const returnUrlTiposComprobantePage =
    ROUTER_PATHS.administration.tipoComprobanteNav;
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(tipoComprobanteFormSchema),
    defaultValues: {
      estado: true,
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* mutations
  const createTipoComprobanteMutation = useCreateTipoComprobante({
    navigate,
    returnUrl: returnUrlTiposComprobantePage,
  });
  const updateTipoComprobanteMutation = useUpdateTipoComprobante({
    navigate,
    returnUrl: returnUrlTiposComprobantePage,
  });

  ///* handlers
  const onSave = async (data: SaveFormData) => {
    if (!isValid) return;

    ///* upd
    if (tipocomprobante?.id_tipocomprobante) {
      updateTipoComprobanteMutation.mutate({
        id: tipocomprobante.id_tipocomprobante!,
        data,
      });
      return;
    }

    ///* create
    createTipoComprobanteMutation.mutate(data);
  };

  ///* effects
  useEffect(() => {
    if (!tipocomprobante?.id_tipocomprobante) return;
    reset(tipocomprobante);
  }, [tipocomprobante, reset]);

  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlTiposComprobantePage)}
      onSave={handleSubmit(onSave, () => { })}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre}
        error={errors.nombre}
        helperText={errors.nombre?.message}
      />
      <CustomTextField
        label="Código SRI"
        name="codigo_sri"
        control={form.control}
        defaultValue={form.getValues().codigo_sri}
        error={errors.codigo_sri}
        helperText={errors.codigo_sri?.message}
      />
      <CustomTextArea
        label="Descripcion"
        name="descripcion"
        control={form.control}
        defaultValue={form.getValues().descripcion}
        error={errors.descripcion}
        helperText={errors.descripcion?.message}
      />

      <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        size={gridSizeMdLg6}
        disabled={!!tipocomprobante?.id_tipocomprobante}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={form.getValues().estado}
        size={gridSizeMdLg6}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveTipoComprobante;
